/* eslint-disable react-hooks/exhaustive-deps */
import { Box, TablePagination, type TablePaginationClassKey } from "@mui/material";
import { FC, ReactNode, useCallback } from "react";
import { useObservable } from "src/framework/store/storeUtil";
import { EasyDataGridStore } from "./store";
import "./styles.scss";
import type { ClassNameMap } from "@mui/styles";

interface IEasyDataGrid {
    store: EasyDataGridStore,
    rowsRender: (rows: any) => ReactNode
    renderFilter?: () => ReactNode
    paginationClasses?: Partial<ClassNameMap<TablePaginationClassKey>>;
}

const EasyDataGrid: FC<IEasyDataGrid> = ({ paginationClasses, store, rowsRender, renderFilter = () => "",}) => {
    const page = useObservable(store.page);
    const perPage = useObservable(store.perPage);
    const total = useObservable(store.total);
    const rows = useObservable(store.rows);
    const perPageList = useObservable(store.perPageList);

    const handleChangePage = useCallback((_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        store.setPage(newPage + 1);
        store.list();
    }, []);

    const handleChangeRowsPerPage = useCallback((
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        store.setRows([]);
        store.setPerPage(parseInt(event.target.value));
        store.setPage(1);
        store.list();
    }, []);

    return <div className="EasyDataGrid">
        <Box className="header">{renderFilter?.()}</Box>
        <Box className="content">
            {rowsRender(rows)}
        </Box>
        <Box className="footer" alignContent="center">
            <TablePagination
                component="div"
                classes={paginationClasses}
                count={total || 0}
                page={(page - 1)}
                onPageChange={handleChangePage}
                rowsPerPage={perPage || 0}
                rowsPerPageOptions={perPageList || []}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={"Registros por página:"}
                labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} de ${count} registros`
                }
            />
        </Box>
    </div>
}

export { EasyDataGrid };